import React, { useEffect } from "react";

const LoaderOverlay = () => {
  useEffect(() => {
    // Create a <style> tag and inject keyframes once
    const styleTag = document.createElement("style");
    styleTag.innerHTML = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(styleTag);

    return () => {
      // Cleanup when component unmounts
      document.head.removeChild(styleTag);
    };
  }, []);

  return (
    <div style={styles.overlay} data-testid="loader-overlay">
      <div style={styles.spinner}></div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100vw",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  spinner: {
    width: "60px",
    height: "60px",
    border: "6px solid #f3f3f3",
    borderTop: "6px solid #086DAB",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
};

export default LoaderOverlay;
